var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNumberField = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 32,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 30,
  x: 1,
  y: 1,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-border-strong)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m142.108 11.346 3.531-3.53 3.531 3.53m0 9.308-3.531 3.53-3.531-3.53"
})));
export default SvgNumberField;